<template>
  <div>
    <b-card
      title="Link tags to business"
      sub-title="Search tags to link them to this business"
    >
      <LinkNewTags
        :business-id="businessId"
        @tags-added="fetchList"
      />
    </b-card>
    <b-card title="Business Tags">
      <base-overlay :show="loading">
        <b-table
          hover
          striped
          :items="list"
          :fields="tableColumns"
          show-empty
          empty-text="Empty"
        >
          <template #cell(actions)="data">
            <b-button
              :disabled="data.item.deleting"
              class="btn-icon rounded-circle"
              variant="flat-danger"
              @click="deleteTagHandler(data.item)"
            >
              <b-spinner
                v-if="data.item.deleting"
                small
              />
              <feather-icon
                v-else
                icon="TrashIcon"
              />
            </b-button>
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          class="mt-1"
          :total="total"
          @input="fetchList"
          @new-per-page="queryParams.perPage = $event"
        />
      </base-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BTable, BCard, BButton, BSpinner,
} from 'bootstrap-vue'
import {
  ref, reactive, toRef, watch,
} from '@vue/composition-api'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import BasePagination from '@/UI/BasePagination.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../../../../store'
import LinkNewTags from './LinkNewTags.vue'
// import formatDate from '@/utils/date-format'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BSpinner,
    BaseOverlay,
    LinkNewTags,
    BasePagination,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('business', businessStore)
    const loading = ref(false)
    const total = ref(0)
    const list = ref([])
    const tableColumns = [
      {
        label: 'Name En',
        key: 'name.en',
      },
      { label: 'Name Ar', key: 'name.ar' },
      { key: 'slug' },
      { label: '', key: 'actions' },
    //   { key: 'createdAt', formatter: val => formatDate(val) },
    //   { key: 'updatedAt', formatter: val => formatDate(val) },
    ]
    const queryParams = reactive({
      perPage: 10,
      page: 1,
    })

    const fetchList = async () => {
      loading.value = true
      const result = await ctx.root.$store.dispatch('business/getBusinessTags', {
        params: queryParams,
        businessId: props.businessId,
      })
      const { tags, total: totalRecords } = result.data.data

      list.value = tags.map(el => ({
        ...el,
        deleting: false,
      }))

      total.value = totalRecords
      loading.value = false
    }
    watch([toRef(queryParams, 'perPage')], () => {
      fetchList()
    })
    fetchList()

    const deleteTagHandler = async tag => {
      // eslint-disable-next-line no-param-reassign
      tag.deleting = true
      try {
        await ctx.root.$store.dispatch('business/unlinkTagFromBusiness', {
          businessId: props.businessId,
          tagId: tag.id,
        })
        fetchList()
      } finally {
        // eslint-disable-next-line no-param-reassign
        tag.deleting = false
      }
    }
    return {
      deleteTagHandler,
      tableColumns,
      queryParams,
      list,
      total,
      fetchList,
      loading,
    }
  },
}
</script>
